import AdvisorBackendService from 'AdvisorBackendService';
import BackendService from 'BackendService';
import TokenData from 'TokenData';
import { FundOpportunityEOIController } from './controller';

export function getBackendService(
  ctx: FundOpportunityEOIController,
): BackendService | AdvisorBackendService {
  // The admin preview needs admin methods, so use the regular BackendService;
  // an advisor (outside the admin preview) uses AdvisorBackendService.
  const service = ctx.props.adminView
    ? new BackendService()
    : ctx.props.advisorMode
      ? new AdvisorBackendService()
      : new BackendService();

  // If we have an asset storage token from props, override setupAssetStorage
  // to use it instead of calling the backend
  if (ctx.state.assetStorageToken) {
    const token = ctx.state.assetStorageToken;
    // Override setupAssetStorageWithRetry to return the token from state
    (service as any).setupAssetStorageWithRetry = (
      _forceRetrieve: boolean,
      _maxRetries: number = 3,
    ): Promise<TokenData> => {
      return Promise.resolve(token);
    };
  }

  return service;
}
